// extracted by css-extract-rspack-plugin
export default {"ViewButton":"gm5S8","active":"d8uaN"};